import { Injectable } from '@angular/core';
import { VaccineStockModel } from '../../../models/master-data/vaccine-stock.model';
import { MasterDataUrl } from '../../../shared/urls/master-data.urls';
import { BaseService } from '../../../shared/services/base.service';

@Injectable()
export class VaccineService {
    constructor(public baseService: BaseService) {
    }

    getVaccineList(param) {
        const url = MasterDataUrl.GET_ALL_VACCINE;
        return this.baseService.getData(url, param);
    }

    updateVaccine(id, param) {
        const url = MasterDataUrl.UPDATE_VACCINE + `${id}`;
        return this.baseService.update(url, param);
    }

    deleteVaccine(id) {
        const url = MasterDataUrl.REMOVE_VACCINE.replace('{id}', id);
        return this.baseService.delete(url);
    }

    getDefaultCourseData(): any[] {
        return [
            {
                id: 0,
                name: 'B'
            },
            {
                id: 1,
                name: 'D'
            },
            {
                id: 2,
                name: 'P'
            }
        ];
    }

    getSuppliers() {
        const url = MasterDataUrl.GET_ALL_SUPPLIER;
        return this.baseService.getData(url);
    }

    getVaccine(id) {
        const url = MasterDataUrl.GET_VACCINE.replace('{id}', id);
        return this.baseService.getData(url);
    }
    addNewVaccine(param){
        const url = MasterDataUrl.ADD_NEW_VACCINE;
        return this.baseService.postData(url, param);
    }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/master-data/vaccine/vaccine.service.ts